var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import { badgeSizes, badgeTypes, } from './constants';
const variationStyles = {
    [badgeTypes.negativeStrong]: {
        backgroundColor: theme.colors.surfaceSemanticError,
        color: theme.colors.gray100,
    },
    [badgeTypes.negativeLight]: {
        backgroundColor: theme.colors.surfaceSemanticErrorSubtle,
        color: theme.colors.gray700,
    },
    [badgeTypes.positiveStrong]: {
        backgroundColor: theme.colors.surfaceSystemTertiaryInverse,
        color: theme.colors.gray100,
    },
    [badgeTypes.positiveLight]: {
        backgroundColor: theme.colors.surfaceSemanticSuccessSubtle,
        color: theme.colors.gray700,
    },
};
const sizeStyles = {
    [badgeSizes.extraSmall]: theme.typeStyles.captionSmallStyles,
    [badgeSizes.small]: theme.typeStyles.captionSmallStyles,
    [badgeSizes.medium]: theme.typeStyles.captionMediumStyles,
    [badgeSizes.large]: theme.typeStyles.captionLargeStyles,
};
const defaultProps = {
    size: 'medium',
    type: 'positiveLight',
};
const Badge = (_a) => {
    var { children, size = defaultProps.size, type = defaultProps.type } = _a, props = __rest(_a, ["children", "size", "type"]);
    const badgeStyles = useMemo(() => (css `
        ${sizeStyles[size]}
        ${type !== 'custom' && css `
          background-color: ${variationStyles[type].backgroundColor};
          color: ${variationStyles[type].color};
        `}
        padding-bottom: ${theme.spacing.base};
        padding-left: ${theme.spacing.x2};
        padding-right: ${theme.spacing.x2};
        padding-top: ${theme.spacing.base};
        ${size === 'extraSmall' && css `
          padding-bottom: calc(${theme.spacing.base} / 2);
          padding-left: ${theme.spacing.base};
          padding-right: ${theme.spacing.base};
          padding-top: calc(${theme.spacing.base} / 2);
        `}
      `), [
        size,
        type,
    ]);
    return (_jsx("div", Object.assign({ className: 'className' in props ? props.className : undefined, css: badgeStyles }, { children: _jsx("span", { children: children }) })));
};
const MemoizedBadge = memo(Badge);
export { MemoizedBadge as Badge };
// MC-1068 Temporary hack for Storybook.
export default Badge;
